import { useEffect } from 'react';
import { tracking } from '@iwoca/frontend-tracking-library';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { isIwocaDE } from 'utils/countryHelper';

export const useTrackingIdentify = () => {
  const { introducerId, introducerType } = useIntroducerData();

  function isImpersonating() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('__impersonate');
  }

  useEffect(() => {
    if (introducerId && introducerType) {
      tracking.identifyIntroducer({
        introducerId: introducerId,
        country: isIwocaDE() ? 'DE' : 'UK',
        isImpersonating: isImpersonating(),
        Project: 'Introducer portal',
        site: isIwocaDE() ? 'DE' : 'UK',
        'Introducer type': introducerType,

        // Browser properties
        'Browser width': window.innerWidth,
        'Browser height': window.innerHeight,
        'Browser width maximum': window.screen.availWidth,
        'Browser height maximum': window.screen.availHeight,
        'Device category': getDeviceCategory(),
      });
    }
  }, [introducerId, introducerType]);
};

const getDeviceCategory = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'Tablet';
  } else if (
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua,
    )
  ) {
    return 'Mobile';
  } else {
    return 'Desktop';
  }
};
